// JWT 토큰 관리 유틸리티
import axios from 'axios'
import { API_BASE_URLS } from './apiConfig.js'

// 토큰 저장
export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('access_token', accessToken)
  localStorage.setItem('refresh_token', refreshToken)
}

// 토큰 가져오기
export const getTokens = () => {
  return {
    accessToken: localStorage.getItem('access_token'),
    refreshToken: localStorage.getItem('refresh_token')
  }
}

// 토큰 삭제
export const clearTokens = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
}

// 액세스 토큰이 유효한지 확인 (간단한 체크)
export const isTokenValid = () => {
  const token = localStorage.getItem('access_token')
  if (!token) return false
  
  try {
    // JWT 토큰의 payload 부분 디코딩
    const payload = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Date.now() / 1000
    return payload.exp > currentTime
  } catch (error) {
    return false
  }
}

// 액세스 토큰 재발급
export const refreshAccessToken = async () => {
  const { refreshToken } = getTokens()
  if (!refreshToken) {
    throw new Error('No refresh token available')
  }

  try {
    const response = await axios.post(`${API_BASE_URLS.krit}/users/refresh_access_token`, {
      refresh_token: refreshToken
    })

    if (response.data.response) {
      localStorage.setItem('access_token', response.data.access_token)
      return response.data.access_token
    } else {
      throw new Error('Token refresh failed')
    }
  } catch (error) {
    // 리프레시 토큰도 만료된 경우 모든 토큰 삭제
    clearTokens()
    throw error
  }
}

// Authorization 헤더 생성
export const getAuthHeader = () => {
  const token = localStorage.getItem('access_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}
